import { render, staticRenderFns } from "./ExpenseDetails.vue?vue&type=template&id=5db0b206&scoped=true&"
import script from "./ExpenseDetails.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDetails.vue?vue&type=style&index=0&id=5db0b206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0b206",
  null
  
)

export default component.exports